import React from 'react';
import { SearchSelect } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/components/SearchSelect';
import { useAppSelector } from 'src/utils/Hooks';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';

export const SegmentSelect = () => {
  const {
    selections: { control }
  } = usePresentationFormContext();
  const segments = useAppSelector((state) => [...state.segments.mySegments, ...state.segments.teamSegments]);

  const selectOptions = segments.map((segment) => ({
    id: segment.id,
    value: segment.id,
    displayName: segment.displayName
  }));

  return (
    <SearchSelect
      name="entityId"
      title="Segment Inclusions"
      placeholder="Search or select the segment you would like to add to your presentation"
      selectOptions={selectOptions}
      control={control}
    />
  );
};
